import React from "react";

import { useLazyQuery } from "@apollo/client";
import { Box, Button, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import CustomTextInput from "../../Components/CustomTextInput/CustomTextInput";
import {
  Query,
  QueryGeneratorOtpArgs,
} from "../../graphql/__generated__/types";
import { GENERATOR_OTP } from "../../graphql/resetPassword/query";
import { stylesx } from "./style";

interface FormValues {
  email: string;
}

const defaultValues: FormValues = {
  email: "",
};

const Forgotpassword: React.FC = () => {
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>();

  // "cache-first" (defaut du client) renverrait le resultat memorise si
  // l'utilisateur redemande un code pour la meme adresse : aucun appel serveur,
  // donc aucun nouveau code envoye alors que l'ecran affiche un succes.
  const [SendOtp] = useLazyQuery<Query, QueryGeneratorOtpArgs>(GENERATOR_OTP, {
    fetchPolicy: "network-only",
  });

  const OnPressSendOTP = async ({ email }: FormValues) => {
    const { data } = await SendOtp({
      variables: {
        input: { email },
      },
    });
    const idUser = data?.GeneratorOtp?.id;
    if (idUser) {
      // L'identifiant ne transite pas par l'URL : il resterait dans
      // l'historique du navigateur et s'enumererait trivialement. Il passe par
      // l'etat du routeur, que l'ecran suivant recopie en sessionStorage pour
      // survivre au rechargement. L'adresse l'accompagne : elle est necessaire
      // au renvoi de code.
      navigate("/resetpassword", { state: { idUser, email } });
      reset(defaultValues);
    }
  };
  return (
    <Box sx={stylesx.box}>
      <FaLock size={100} color="#d4d6d5" />
      <Typography style={{ marginBottom: 20, fontWeight: "500" }}>
        Mot de passe oublié ?
      </Typography>
      <Typography>
        Veuillez saisir votre adresse e-mail afin de réinitialiser votre mot de
        passe.
        <Typography>
          Un code de réinitialisation vous sera ensuite envoyé à cette adresse.
        </Typography>
      </Typography>
      <Controller
        control={control}
        render={({ field: { onChange, value } }) => (
          <CustomTextInput
            id="E-mail *"
            label="E-mail *"
            fullWidth={false}
            style={{ width: "50%" }}
            onChange={onChange}
            error={!!errors.email}
            value={value}
            helperText={errors.email?.message}
          />
        )}
        name="email"
        rules={{
          required: {
            value: true,
            message: "Ce champ est réquis",
          },
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Veuillez entrer une adresse e-mail valide.",
          },
        }}
        defaultValue=""
      />

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(OnPressSendOTP)}
          style={{ textTransform: "none" }}
        >
          Envoyer
        </Button>
        <Button
          variant="contained"
          color="inherit"
          style={{ textTransform: "unset", marginLeft: "10px" }}
          onClick={() => navigate(-1)}
        >
          Retour
        </Button>
      </div>
    </Box>
  );
};
export default Forgotpassword;
